import type { TableProps } from 'antd'
import { Avatar, Button, Flex, Space, Table, theme, Typography } from 'antd'
import type { Channel } from '@entities/channel'
import { categories } from '@entities/channel'
import React, { useMemo } from 'react'
import { EyeOutlined, TeamOutlined } from '@ant-design/icons'
import { useTokens } from '@entities/token'
import { tableData } from '@pages/stock-buy-advertising/ui/constants'

const { Text } = Typography

export const TableView = () => {
    const { isTokensLoading } = useTokens()

    const {
        token: { colorPrimary }
    } = theme.useToken()

    const columns: TableProps<Channel>['columns'] = useMemo(
        () => [
            {
                title: 'Название канала',
                dataIndex: 'name',
                key: 'name',
                render: (_, record) => (
                    <Space>
                        <Avatar src={record.photoUrl || `${record.url}/favicon.ico`} />
                        <Text>{record.name || record.username || record.url}</Text>
                    </Space>
                )
            },
            {
                title: 'Username',
                dataIndex: 'username',
                key: 'username'
            },
            {
                title: 'Подписчики',
                dataIndex: 'membersCount',
                key: 'membersCount',
                render: (_, record) => (
                    <Flex gap={3}>
                        <TeamOutlined style={{ color: colorPrimary }} />
                        <Text style={{ color: colorPrimary }}>{record.membersCount}</Text>
                    </Flex>
                )
            },
            {
                title: 'Категория',
                dataIndex: 'category',
                key: 'category',
                render: (_, record) => categories.find((c) => c.value === record.category)?.label
            },
            {
                title: 'Тип',
                dataIndex: 'type',
                key: 'type',
                render: (_, record) => (
                    <Button style={{ borderColor: colorPrimary, color: colorPrimary }}>{record.type}</Button>
                )
            },
            {
                title: 'Цена',
                dataIndex: 'cost',
                key: 'cost'
            },
            {
                title: 'Средний охват',
                dataIndex: 'averageCoverage',
                key: 'averageCoverage',
                render: (_, record) => (
                    <Flex gap={3}>
                        <EyeOutlined style={{ color: colorPrimary }} />
                        <Text style={{ color: colorPrimary }}>{record.membersCount}</Text>
                    </Flex>
                )
            },
            {
                title: 'Прирост за 30 дней',
                dataIndex: 'growth30',
                key: 'growth30',
                render: (_, record) => (
                    <Flex gap={3}>
                        <TeamOutlined style={{ color: colorPrimary }} />
                        <Text style={{ color: colorPrimary }}>{record.membersCount}</Text>
                    </Flex>
                )
            },
            {
                title: '',
                dataIndex: '',
                key: '',
                render: (_, record) => <Button type="primary">Подробнее</Button>
            },
            {
                title: '',
                dataIndex: '',
                key: '',
                render: (_, record) => <Button type="primary">Закуп</Button>
            }
        ],
        []
    )

    return (
        <Table<Channel>
            columns={columns}
            dataSource={tableData}
            pagination={false}
            rowKey={'id'}
            size={'small'}
            loading={isTokensLoading}
            scroll={{
                y: 'calc(100vh - 380px)'
            }}
        />
    )
}
